import React from 'react';

const useSetEditableState = (
  editable,
  value,
  SelectableDataArray,
  setUiValue,
  onChange
) => {
  React.useEffect(() => {
    if (
      editable &&
      value !== null &&
      value !== undefined &&
      SelectableDataArray
    ) {
      setUiValue(value);
      onChange(value);
    }
  }, [value, SelectableDataArray]);
};

export default useSetEditableState;
